export let TypePlugin;

(function (TypePlugin) {
  TypePlugin["ReqPluginOpen"] = "REQ.PLUGIN.OPEN";
  TypePlugin["ReqPluginClose"] = "REQ.PLUGIN.CLOSE";
  TypePlugin["ReqPluginStyle"] = "REQ.PLUGIN.STYLE";
})(TypePlugin || (TypePlugin = {}));